import React, { FC, ReactNode, useState } from 'react';

import { Button } from 'src/components/Button';
import { Container } from 'src/components/Container';
import { Modal } from 'src/components/Modal/Modal';

export type ConfirmModalProps = {
  title: string;
  message: ReactNode;
  confirmText?: string;
  cancelText?: string;
  confirmClassName?: string;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  isLoading?: boolean;
};

export const ConfirmModal: FC<ConfirmModalProps> = ({
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmClassName = 'black',
  onClose,
  onConfirm,
  isLoading = false,
}) => {
  const [confirming, setConfirming] = useState(false);
  const busy = isLoading || confirming;

  const handleConfirm = async () => {
    setConfirming(true);
    try {
      await onConfirm();
    } finally {
      setConfirming(false);
    }
  };

  const footer = (
    <Container display="flex" gap="0.75rem" justifyContent="flex-end" width="100%">
      <Button text={cancelText} className="outline" onClick={onClose} disabled={busy} />
      <Button
        text={confirmText}
        className={confirmClassName}
        onClick={handleConfirm}
        disabled={busy}
        isLoading={busy}
      />
    </Container>
  );

  return (
    <Modal isOpen onClose={onClose} footer={footer}>
      <Container fontWeight={600} fontSize="1.25rem" paddingBottom="0.75rem">
        {title}
      </Container>
      <Container fontSize="0.9375rem" lineHeight={1.5}>
        {message}
      </Container>
    </Modal>
  );
};
